import React from 'react';
import * as ReactDOMClient from 'react-dom/client';

import ImageUpload from './Common/ImageUpload.js';

import MissionDetails from './EditMission/MissionDetails.js';
import MissionLaunch from './EditMission/MissionLaunch.js';
import MissionPrivacy from './EditMission/MissionPrivacy.js';
import MissionTimeframe from './EditMission/MissionTimeframe.js';
import MissionTerms from './EditMission/MissionTerms.js';

var body = window.jQuery("html, body");

class NewMission extends React.Component {
	constructor(props) {
		super(props);

		this.state = { 
			missionType: 'solo', 
			groups: [], 
			group: { 
				id: 0, 
				name: '', 
				description: '', 
				billing_platform_type: '',
				billing_currency_id: 1,
				imagePath: '',
				imageValidated: true
			}, 
			billingType: '', 
			step: 1,
			mapRendered: false,
			mission: {
				name: '',
				description: '',
				travel_from: '',
				travel_to: '',
				missionTimeframe: 'fixed',
				defaultTimeframe: 56,
				maxTimeframe: 56,
				startDate: window.todayDate,
				endDate: '',
				launchType: 'manual',
				public: 3,
				termsAccepted: false,
			},
			invalid: [],
			dataAgreementAccepted: false
		};

		this.handleChange = this.handleChange.bind(this);
		this.handleChangeMissionParam = this.handleChangeMissionParam.bind(this);
		this.handleChangeDate = this.handleChangeDate.bind(this);
		this.groupImageUploadFinished = this.groupImageUploadFinished.bind(this);

		this.handleOuterNext = this.handleOuterNext.bind(this);
		this.validateAndSave = this.validateAndSave.bind(this);

		this.scrollingStartMission = this.scrollingStartMission.bind(this);
		this.animateScrollingStart = this.animateScrollingStart.bind(this);

		this.steps = 3;

		this.currencies = [
			{id: 1, name: 'United States Dollar', alias: 'USD'},
			{id: 2, name: 'New Zealand Dollar', alias: 'NZD'},
			{id: 3, name: 'Australian Dollar', alias: 'AUD'},
			{id: 4, name: 'Canadian Dollar', alias: 'CAD'},
			{id: 5, name: 'Euro', alias: 'EUR'},
			{id: 6, name: 'British Pound2', alias: 'GBP'}
		];
	}

	componentDidMount() {
		this._getGroups();

		let elementList = document.querySelectorAll('.next-step-btn');

		elementList.forEach((item) => {
			item.addEventListener('click', this.handleOuterNext);
		});
	}

	handleOuterNext(event) {
		const nextStep = parseInt(event.target.dataset.nextstep);

		this.changeStep(nextStep);
	}

	_getGroups() {
		fetch('/default/ajax?ajax=newmission_get_groups', {
			method: 'GET',
			headers: {
				Accept: 'application/json'
			}
		})
		.then(res => res.json())
	    .then(
	        (data) => {
				this.setState({groups: data.groups})
	        },
	        // Note: it's important to handle errors here
	        // instead of a catch() block so that we don't swallow
	        // exceptions from actual bugs in components.
	        (error) => {
	        	//this.setState({errored:true});
	        }
	    )
	}

	handleChange(event) {
		const target = event.target;
	    const value = target.type === 'checkbox' ? target.checked : target.value;
	    const name = target.name;

	    if (name === 'groupName') {
	    	if (value != '') {
	    		this.setState(prevState => {
	    			let group = { ...prevState.group };
	    			group.id = 'new';
	    			group.name = value;
	    			group.billing_platform_type = '';

	    			return { group };
	    		});
	    	}
	    	else {
	    		this.setState(prevState => {
	    			let group = { ...prevState.group };
	    			group.id = 0;
	    			group.name = '';
	    			group.billing_platform_type = '';

	    			return { group };
	    		});
	    	}
	    }
	    else if (name === 'groupDescription') {
    		this.setState(prevState => {
    			let group = { ...prevState.group };
    			group.description = value;

    			return { group };
    		});
	    }
	    else if (name === 'groupCurrency') {
    		this.setState(prevState => {
    			let group = { ...prevState.group };
    			group.billing_currency_id = value;

    			return { group };
    		});
	    }
	    else if (name === 'groupId') {

			const group = this.state.groups.find(function(g) {
				return g.id == value
			});

	    	if (value != '') {
				group.imageValidated = true;
		    	this.setState({group: group, billingType: group.billing_platform_type});

		    	this.setState(prevState => {
	    			let mission = { ...prevState.mission };
					let group = { ...prevState.group };

	    			if (parseInt(mission.maxTimeframe) > parseInt(group.billing_max_duration)) {
	    				mission.maxTimeframe = parseInt(group.billing_max_duration);
	    			}
	    			if (mission.defaultTimeframe > mission.maxTimeframe) {
	    				mission.defaultTimeframe = 7;
	    			}

	    			return { mission };
	    		});
		    }
		    else {
		    	this.setState({group: { id: 0, name: '', description: '', imageValidated: true, billing_platform_type: '' }, billingType: ''});
		    }
	    }
	    else {
		    this.setState({
		    	[name]: value
		    });	
	    }
	    

		//this.setState({ missionType: event.target.value});
	}

	handleChangeMissionParam(event) {
		const target = event.target;
	    const value = target.type === 'checkbox' ? target.checked : target.value;
		const name = target.name;	
		
	    this.setState(prevState => {
			let mission = { ...prevState.mission };
			mission[name] = value;

			return { mission };
		});
	}

	validateAndSave() {
		if (this.validateStep(3)) {
			let formFields = {
				type: this.state.missionType,
				group: this.state.group,
				billing_type: this.state.billingType,
				mission: this.state.mission
			}

			const updatedMapData = window.getUpdatedMapData();

			document.querySelector('input[name="map_data"]').value = updatedMapData;

			document.querySelector('input[name="state"]').value = JSON.stringify(formFields);

			this.scrollingStartMission();
		}
		else {
			// jQuery
			body.stop().animate({scrollTop:0}, 250, 'swing');
		}
	}

	validateStep(step) {
		let valid = true;
		//return valid;//for testing

		let mission = this.state.mission;
		let missionKmTarget = parseFloat(document.querySelector('input[name="km_target"]').value);

		let invalidMessages = [];

		switch(step) {
			case 1:
				//
				if (this.state.missionType === 'group') {
					if (!this.state.group.id > 0) {
						valid = false;
						invalidMessages.push('Group information is required.');
					}
					else if (this.state.group.id === 'new') {
						if (this.state.group.name == '' || this.state.group.description == '') {
							valid = false;
							invalidMessages.push('Group name and description is required.');
						}
					}
					if (!this.state.billingType) {
						valid = false;
						invalidMessages.push('Group type selection is required.');
					}
				}
			break;

			case 2:

				if (!(missionKmTarget > 0)) {
					valid = false;
					invalidMessages.push('Mission path is required.');
				}
			break;

			case 3:
				if (mission.travel_from.length < 1) {
					valid = false;
					invalidMessages.push('Mission Origin is required.');	
				}
				if (mission.travel_to.length < 1) {
					valid = false;
					invalidMessages.push('Mission Destination is required.');	
				}
				if (mission.name.length < 1) {
					valid = false;
					invalidMessages.push('Mission Name is required.');	
				}
				if (mission.description.length < 1) {
					valid = false;
					invalidMessages.push('Mission Description is required.');	
				}
				if (!mission.termsAccepted && this.state.missionType === 'group') {
					valid = false;
					invalidMessages.push('Please agree with the Terms of Service.');	
				}

				const startDateParts = mission.startDate.split(' ');
				const endDateParts = mission.endDate.split(' ');

				let diffDays = 0;
				let billingMaxDuration = 365;
				if (this.state.missionType === 'solo') {
					billingMaxDuration = 1095; // 3 years
				}
				else if (parseInt(this.state.group.billing_max_duration) > 0) {
					billingMaxDuration = parseInt(this.state.group.billing_max_duration);
				}
				else {
					billingMaxDuration = 92; // maximum number of days that any 3month span in a calendar year can have
				}

				let maxOngoingWeeks = Math.floor(billingMaxDuration/7);

				if (mission.missionTimeframe === 'fixed') {
					if (mission.endDate == '') {
						valid = false;
						invalidMessages.push('Mission start and end date are required for fixed length missions.')
					}
					else {
						startDateParts[0] = startDateParts[0].match(/\d+/)[0];
						startDateParts[1] = this.getMonthFromName(startDateParts[1]);
						endDateParts[0] = endDateParts[0].match(/\d+/)[0];
						endDateParts[1] = this.getMonthFromName(endDateParts[1]);

						const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
						const secondDate = new Date(startDateParts[2], startDateParts[1], startDateParts[0]);
						const firstDate = new Date(endDateParts[2], endDateParts[1], endDateParts[0]);
						diffDays = Math.round(Math.abs((firstDate - secondDate) / oneDay));

						if (diffDays > billingMaxDuration) {
							valid = false;
							invalidMessages.push('Your start and end dates are invalid because the maximum allowable timeframe of your group is '+billingMaxDuration+' days. Please change the timeframe or contact your account manager to extend your max timeframe.');
						}
					}
				}
				else {
					if (mission.maxTimeframe > billingMaxDuration) {
						valid = false;
						invalidMessages.push('A valid maximum duration is required (no longer than '+maxOngoingWeeks+' weeks)');
					}
				}
			break;

			default:
				valid = false;
			break;
		}

		this.setState({invalid: invalidMessages});

		return valid;
	}

	getMonthFromName(monthName) {
		const months = {
		    'Jan' : 0,
		    'Feb' : 1,
		    'Mar' : 2,
		    'Apr' : 3,
		    'May' : 4,
		    'Jun' : 5,
		    'Jul' : 6,
		    'Aug' : 7,
		    'Sep' : 8,
		    'Oct' : 9,
		    'Nov' : 10,
		    'Dec' : 11
		}

		return months[monthName];
	}

	validateStepCompletion(nextStep) {
		// Validate all steps prior to this step.
		let ct = 1;
		while (ct < nextStep) {
			let result = this.validateStep(ct);

			if (!result) {
				// Go to earliest page
				this.changeStep(ct, true);
				return false;
			}

			ct++;
		}

		return true;
	}

	changeStep(newStep,noValidatePreviousSteps) {
		if (typeof noValidatePreviousSteps === 'undefined' && !this.validateStepCompletion(newStep)) {
			// Above function will return to the earliest step where there's a validation problem
			return false;
		}

		this.setState({step: newStep});

		if (newStep === 2) {
			document.querySelector('#step-2').style.display="block";

			if (!this.state.mapRendered) {
				this.setState({mapRendered:true})
				newMissionMapInit();
			}
		}
		else {
			document.querySelector('#step-2').style.display="none";
		}


		// jQuery
		body.stop().animate({scrollTop:0}, 250, 'swing');
	}

	handleChangeDate(name, newDate) {
		this.setState(prevState => {
			let mission = { ...prevState.mission };
			mission[name] = newDate;

			return { mission };
		});

		return true;
	}

	groupImageUploadFinished(data) {
		this.setState(prevState => {
			let group = { ...prevState.group };
			group.imagePath = data.image.path;
			group.imageValidated = true;

			return { group };
		});

		return true;
	}

	invalidImage() {
		this.setState(prevState => {
			let group = {...prevState.group};
			group.imageValidated = false;

			return {group};
		});

		return true;
	}

	scrollingStartMission() {
		const $ = window.jQuery;

		$('#scrolling-start-spinner').show();
		// // Expand the height of the wrap element
		// $('#scrolling-start-wrap').animate({height:'330px'});
		// // Scroll to the position
		// body.animate({scrollTop: $('#scrolling-start-wrap').offset().top}, 100);
		// // Start the scrolling
		// window.scrollingStartPIndex = 1;
		// this.animateScrollingStart();
		// window.scrollingStartIntHandler = setInterval(() => {this.animateScrollingStart(); },3200);	//3200

		// setTimeout(function() {
			$('#new-mission-form').submit();
		// },3000);
	}

	animateScrollingStart() {
		const $ = window.jQuery;

		$('#scrolling-start > p#ind-'+window.scrollingStartPIndex).show().ticker({
			cursorList: "_",
			rate: 18
		}).trigger('play').trigger('stop');

		window.scrollingStartPIndex += 1;

		if (scrollingStartPIndex > 10) {
			clearInterval(window.scrollingStartIntHandler);
		}
	}

	render() {
		return (
			<div>
				<div id="step-navigation mb-4">
					<div className="container">
						<ul className="nav nav-pills mb-4">
							<li className="nav-item"><button type="button" className={(this.state.step==1 ? 'active' : '')+" nav-link"} onClick={() => { this.changeStep(1); }}>1. Mission Type</button></li>
							<li className="nav-item"><button type="button" className={(this.state.step==2 ? 'active' : '')+" nav-link"} onClick={() => { this.changeStep(2); }}>2. Map Setup</button></li>
							{this.state.step>=2 ? (
								<li className="nav-item"><button type="button" className={(this.state.step==3 ? 'active' : '')+" nav-link"} onClick={() => { this.changeStep(3); }}>3. Mission Information</button></li>
								) : (
								<li className="nav-item"><button type="button" disabled className={(this.state.step==3 ? 'active' : '')+" nav-link"} onClick={() => { this.changeStep(3); }}>3. Mission Information</button></li>
								)}
						</ul>
					</div>
				</div>
				{this.state.invalid.length > 0 && (
					<div className="alert alert-danger mt-3">
						{this.state.invalid.map(function(item, index) {
							return <div key={index}>{item}</div>
						})}
					</div>
				)}
				<div className="container">
					{this.state.step === 1 && (
						<div>
							<h3>NOTE: TO JOIN AN EXISTING MISSION, FOLLOW THE MISSION LINK SHARED BY YOUR ADMIN OR CONTACT YOUR MISSION ADMIN FOR ASSISTANCE</h3>
							<br />
							<h2>STEP 1 - <span className="secondary-color"> CHOOSE YOUR MISSION TYPE</span></h2>
							<p>Choose either a solo mission or group mission.</p>

							<div className="edit-mission-box">
								<label className="edit-mission-timeframe-radio">
									<div>
										<input className="form-check-input" type="radio" name="missionType" onChange={this.handleChange} value="solo" checked={this.state.missionType === 'solo'}/>
									</div>
									<div className="ms-3">
										<h3>Solo Mission - One person on the mission</h3>

										<ul>
											<li>You're off on your own personal mission!</li>
											<li>Create your own custom mission pathway</li>
											<li>See yourself on the map and streetview (where available)</li>
											<li>Your first mission is free for 30 days!</li>
										</ul>
										<strong>Things you should know about solo missions</strong>
										<ul>
											<li>Unlock unlimited missions of any duration for only $23.99 USD per year</li>
										</ul>
									</div>
								</label>
							</div>

							<div className="edit-mission-box">
								<label className="edit-mission-timeframe-radio">
									<div>
										<input className="form-check-input" type="radio" name="missionType" onChange={this.handleChange} value="group" checked={this.state.missionType === 'group'} />
									</div>
									<div className="ms-3">
										<h3>Group Mission - Multiple people on the mission</h3>

										<ul>
											<li>Create your own custom group mission anywhere in the world</li>
											<li>Each person has their own account and can post their own distances</li>
											<li>Set either a fixed  timeframe or have an ongoing mission that your participants can join at any time</li>
											<li>Dynamic leaderboards showing weekly, monthly and all time team and individuals progress</li>
											<li>Create teams or let people enter as individuals</li>
											<li>Admin dashboard to manage the mission</li>
											<li>Perfect for workplace wellness missions and for virtual race hosts</li>
										</ul>
										<strong>Things you should know about group missions</strong>
										<ul>
											<li>Billing is required. See next step for details.</li>
										</ul>
									</div>
								</label>
							</div>

							{this.state.missionType === 'group' && (
								<div className="mt-5">
									<h2>GROUP SETUP</h2>
									<p>Select an existing group for this mission or create a new group.</p>

									<div className="card mission-type-option">
										<div className="card-body">

											<div className="">
												<select name="groupId" onChange={this.handleChange} value={this.state.group.id} className="form-select">
													<option value="">Create New Group</option>
													{this.state.groups.map(function(object, i) {
														let billingPlatformType = 'Legacy'; // won't be in this list
														if (object.billing_platform_type === 'wellness') {
															billingPlatformType = 'Wellness';
														}
														else if (object.billing_platform_type === 'trial_demo') {
															billingPlatformType = 'Trial/Demo';
														}

														return (
															<option key={i} value={object.id}>{object.name} ({billingPlatformType})</option>
														);
													})}
												</select>
											</div>

											{(this.state.group.id === 0 || this.state.group.id==='new') && (
												<div>
													<div className="mt-3">
														<label className="form-label">Group Name</label>
														<input type="text" name="groupName" value={this.state.group.name} onChange={this.handleChange} className="form-control" placeholder="Enter your group name e.g. your company name" />
													</div>

													<div className="mt-3">
														<label className="form-label">Group Description</label>
														<textarea name="groupDescription" value={this.state.group.description} onChange={this.handleChange} className="form-control" placeholder="Enter a description about your group" />
													</div>

													<div className="mt-3">
														<label className="form-label">Billing Currency</label>
														<select name="groupCurrency" onChange={this.handleChange} value={this.state.group.billing_currency_id} className="form-select">
															{this.currencies.map(function(object, i) {
																return (
																	<option key={i} value={object.id}>{object.alias}</option>
																);
															})}
														</select>
														<div className="small text-muted">Trial missions do not incur billing but are required to select a currency.</div>
													</div>

													<div className="mt-3">
														<label className="form-label">Group Image</label>
														<ImageUpload type="new_group" onError={this.invalidImage.bind(this)} onFinish={this.groupImageUploadFinished} textContent={'ADD IMAGE'} />
													</div>

												</div>
											)}
										</div>
									</div>

									{(this.state.group.id > 0 || this.state.group.id === 'new') && (
										<div className="mt-4">
											<h4>GROUP TYPE</h4>
											<p>Select your group mission type.</p>

											{(this.state.group.billing_platform_type === '' || this.state.group.billing_platform_type === 'trial_demo') && (
												<div className="edit-mission-box">
													<label className="edit-mission-timeframe-radio">
														<div>
														<input type="radio" name="billingType" onChange={this.handleChange} value="trial_demo" className="form-check-input" checked={this.state.billingType === 'trial_demo'} style={{marginTop: 4}} />
														</div>
														<div className="ms-3">
															<h3>Trial/Demo Mission</h3>
															<p>Take us for a test drive</p>
															<ul>
																<li>Check out the features of the My Virtual Mission platform</li>
																<li>7-day trial mission</li>
																<li>Up to 6 trial participants</li>
																<li>No billing required</li>
																<li>Highly recommended before creating a live mission</li>
																<li>Trial missions cannot be converted into live missions</li>
															</ul>
														</div>
													</label>
												</div>
											)}

											{(this.state.group.billing_platform_type === '' || this.state.group.billing_platform_type === 'wellness') && (
												<div className="edit-mission-box">
													<label className="edit-mission-timeframe-radio">
														<div>
															<input type="radio" name="billingType" onChange={this.handleChange} value="wellness" className="form-check-input" checked={this.state.billingType === 'wellness'} style={{marginTop: 4}} />
														</div>
														<div className="ms-3">
															<h3>Workplace Wellness</h3>
															<p>Get your workplace moving!</p>
															<ul>
																<li>Minimum charge applies. Please see current pricing <a href="/pricing" target="_blank">here</a></li>
																<li>No payment required until you're ready to launch your mission</li>
																<li>Central "wallet" style billing let's you pay as you go</li>
																<li>People can join before or after you launch your mission</li>
																<li>Billing available in multiple currencies</li>
															</ul>
														</div>
													</label>
												</div>
											)}

										</div>
									)}
								</div>
							)}

							<div className="form-check mt-4">
								<input className="form-check-input" type="checkbox" value="1" id="dataAgreementCheckbox" checked={this.state.dataAgreementAccepted} onChange={() => this.setState({ dataAgreementAccepted: !this.state.dataAgreementAccepted })}  />
								<label className="form-check-label" for="dataAgreementCheckbox">
									I have read and accept the <a href="/data-processing-agreement" target="_blank">Data Processing Agreement</a>
								</label>
							</div>

							<div className="d-flex justify-content-center mt-4">
								{(this.state.group.imageValidated && (this.state.missionType === 'solo' || this.state.billingType !== '') && this.state.dataAgreementAccepted) ? (
									<button type="button" className="bg-img-btn large-btn blue-img" onClick={() => { this.changeStep(2); }}>Next: Map Setup</button>
								) : (
									<button disabled className="bg-img-btn large-btn blue-img" onClick={() => { this.changeStep(2); }} rel="tooltip" title="Please complete all information on this page to move to the next step">Next: Map Setup</button>
								)}
							</div>
						</div>
					)}

					{this.state.step === 3 && (
						<div>
							<h2>STEP 3 - <span className="secondary-color">MISSION INFORMATION</span></h2>
							<br />

							<div className="row">
								<div className="col-12">

									<MissionDetails mission={this.state.mission} handleChange={this.handleChangeMissionParam} />

									<MissionTimeframe mission={this.state.mission} group={this.state.group} missionType={this.state.missionType} billingType={this.state.billingType} handleChange={this.handleChangeMissionParam} handleChangeDate={this.handleChangeDate} />
									<br />

									<MissionPrivacy handleChange={this.handleChangeMissionParam} mission={this.state.mission} />
									<br />

									{this.state.missionType === 'group' && (
										<React.Fragment>
											<MissionTerms handleChange={this.handleChangeMissionParam} isChecked={this.state.areTermsAccepted} />
											<br />
	
											<MissionLaunch handleChange={this.handleChangeMissionParam} mission={this.state.mission} />
										</React.Fragment>
									)}


									<div className="d-flex justify-content-center mt-4">
										<button type="button" className="bg-img-btn large-btn blue-img next-step-btn" onClick={this.validateAndSave} data-nextstep="3">CREATE MISSION</button>
									</div>

									<br />
								</div>
							</div>
						</div>
					)}
				</div>
			</div>
		);
	}
}

const rctNewMission = document.getElementById('rct-newmission');

if (rctNewMission !== null) {
	ReactDOMClient.createRoot(rctNewMission).render(<NewMission />);
}